import { connect } from 'react-redux';
import { actions as profileActions } from '~/profile-sidebar';
import { actions as orgActions } from '~/organizations';
import getOrgIdFromRoute from './utils/getOrgIdFromRoute';

import AppPages from './components/AppPages';

export default connect(
  (state) => {
    const currentPath = state.router.location?.pathname;
    const profiles = state.profileSidebar.profileList;
    const orgIdFromRoute = getOrgIdFromRoute({ currentPath, profiles });
    return {
      unfilteredProfiles: profiles,
      orgIdFromRoute,
      showCalendarAsHomepage: state.user.showCalendarAsHomepage,
    };
  },
  (dispatch) => ({
    profileRouteLoaded: ({ profile, tabId }) => {
      dispatch(
        profileActions.handleProfileRouteLoaded({
          selectedProfile: profile,
          tabId,
        })
      );
    },
    storeSelectedOrg: (currentOrgId) => {
      dispatch(orgActions.setCurrentOrganization(currentOrgId));
    },
  })
)(AppPages);

export { getOrgIdFromRoute };
